// extracted by mini-css-extract-plugin
export default {"navbar":"Navigation_navbar__lllwh","nav-item":"Navigation_nav-item__pWFxc"};